/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

export default {
  install(Vue) {
    Vue.prototype.$approveResult = [
      { code: 1, name: '성공' },
      { code: 2, name: '실패' },
      { code: 3, name: '-' },
    ];
    Vue.prototype.$approveType = [
      { code: 1, name: 'AI 계산' },
      { code: 2, name: 'CS OP 계산' },
    ];
    Vue.prototype.$paymentMode = [
      { code: 1, name: 'App 결제' },
      { code: 2, name: '신용카드 결제' },
      { code: 3, name: '회사ID카드 결제' },
    ];
    Vue.prototype.$state = [
      { code: 1, name: '완전결제 완료', search: true },
      { code: 2, name: '불완전결제 미처리', search: true },
      { code: 3, name: '불완전결제 처리 중', search: false },
      { code: 4, name: '불완전결제 계산 완료', search: false },
      { code: 5, name: '불완전결제 카드 승인 요청', search: false },
      { code: 6, name: '불완전결제 카드 승인 실패', search: true },
      { code: 7, name: '불완전결제 완료', search: true },
      { code: 8, name: '불완전결제 보류', search: true },
      { code: 9, name: '불완전결제 미결제', search: true },
      { code: 10, name: '불완전결제 영구보류', search: true },
      { code: 11, name: '불완전결제 보류 계산 진행', search: false },
      { code: 12, name: '불완전결제 한도미결제', search: true },
      { code: 13, name: '미결제 손실', search: true },
      //
      { code: 101, name: 'CS 계산 진행', search: false },
      { code: 102, name: '취소 계산 완료', search: false },
      { code: 103, name: '취소 카드 승인 요청', search: false },
      { code: 104, name: '취소 실패', search: true },
      { code: 105, name: '취소 완료', search: true },
      //
      { code: 112, name: '재결제 계산 완료', search: false },
      { code: 113, name: '재결제 카드 승인 요청', search: false },
      { code: 114, name: '재결제 취소실패 승인실패', search: true },
      { code: 115, name: '재결제 완료', search: true },
      { code: 141, name: '재결제 취소성공 승인전', search: true },
      { code: 142, name: '재결제 취소전 승인성공', search: true },
      { code: 143, name: '재결제 취소실패 승인전', search: true },
      { code: 144, name: '재결제 취소전 승인실패', search: true },
      { code: 145, name: '재결제 취소실패 승인성공', search: true },
      { code: 146, name: '재결제 취소성공 승인실패', search: true },
      //
      { code: 122, name: '환불', search: true },
      //
      { code: 131, name: '미결제 계산 진행', search: false },
      { code: 132, name: '미결제 계산 완료', search: false },
      { code: 133, name: '미결제 카드 승인 요청', search: false },
      { code: 134, name: '미결제 카드 승인 실패', search: true },
      { code: 135, name: '미결제 완료', search: true },
    ];
    Vue.prototype.$companyScope = [
      { code: 1, name: 'All' },
      { code: 2, name: 'CS' },
      { code: 3, name: 'Biz' },
      { code: 4, name: 'Device' },
    ];
    Vue.prototype.$userRole = [
      { code: 1, name: 'Admin' },
      { code: 2, name: 'Manager' },
      { code: 3, name: 'Operator' },
      { code: 4, name: 'Monitor' },
    ];
    Vue.prototype.$getConstName = (type, code) => {
      const constant = Vue.prototype[`$${type}`];
      if (!constant || constant.length === 0) {
        return null;
      }

      for (let i = 0; i < constant.length; i++) {
        if (constant[i].code === code) {
          return constant[i].name;
        }
      }

      return null;
    };
    Vue.prototype.$getConstCode = (type, name) => {
      const constant = Vue.prototype[`$${type}`];
      if (!constant || constant.length === 0) {
        return null;
      }

      for (let i = 0; i < constant.length; i++) {
        if (constant[i].name === name) {
          return constant[i].code;
        }
      }

      return null;
    };
  },
};



// WEBPACK FOOTER //
// ./src/js/Constant.js